import { render, staticRenderFns } from "./Fblogin.vue?vue&type=template&id=2a71708b&"
import script from "./Fblogin.vue?vue&type=script&lang=js&"
export * from "./Fblogin.vue?vue&type=script&lang=js&"
import style0 from "./Fblogin.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
